<template>
	<a-layout-sider v-model="collapsed" class="navsider">
		<div class="logo">
			<div v-if="!collapsed" style="text-align: center;">Admin后台管理系统</div>
			<div v-if="collapsed" style="font-size: 12px;text-align: center;">Admin</div>
		</div>
		<a-menu theme="dark" :selectedKeys="current" :openKeys="openKey" @openChange="openChange" mode="inline" @click="handleClick"
		 class="navmenu">
			<a-menu-item key="mainpage">
				<a-icon type="home" />
				<span>首页</span>
			</a-menu-item>
			<a-sub-menu key="costcenter">
				<span slot="title">
					<a-icon type="dollar" /><span>费用中心</span></span>
				<a-menu-item key="accountpandect">账户总览</a-menu-item>
				<a-menu-item key="voucher">账户充值</a-menu-item>
			</a-sub-menu>
			<a-sub-menu key="ordermanagement">
				<span slot="title">
					<a-icon type="calendar" /><span>订单管理</span></span>
				<a-menu-item key="transactionlist">交易列表</a-menu-item>
				<a-menu-item key="transactionreconciliation">交易对账</a-menu-item>
			</a-sub-menu>
			<a-menu-item key="membermanagement">
				<a-icon type="smile" />
				<span>会员管理</span>
			</a-menu-item>
			<a-sub-menu key="bdmodule">
				<span slot="title">
					<a-icon type="robot" /><span>BD管理</span></span>
				<a-menu-item key="bdmanagement">BD管理</a-menu-item>
				<a-menu-item key="bdreconciliation">BD交易对账</a-menu-item>
			</a-sub-menu>
			<a-sub-menu key="agentmanagement">
				<span slot="title">
					<a-icon type="inbox" /><span>代理商管理</span></span>
				<a-menu-item key="agentlist">代理管理</a-menu-item>
				<a-menu-item key="agentrank">代理绩效排名</a-menu-item>
				<a-menu-item key="agentcheck">代理商交易对账</a-menu-item>
			</a-sub-menu>
			<a-sub-menu key="usermanagement">
				<span slot="title">
					<a-icon type="team" /><span>用户管理</span></span>
				<a-menu-item key="permissionmanagement">权限组管理</a-menu-item>
				<a-menu-item key="newadministrator">创建新管理员</a-menu-item>
				<a-menu-item key="administratormanagement">管理员管理</a-menu-item>
			</a-sub-menu>
			<a-menu-item key="salemainpage">
				<a-icon type="bar-chart" />
				<span>销售报表</span>
			</a-menu-item>
			<!-- <a-menu-item key="sitesetting">
				<a-icon type="setting" />
				<span>站点设置</span>
			</a-menu-item> -->
		</a-menu>
	</a-layout-sider>

</template>

<script>
	export default {
		name: 'menuBar',
		props: {
			current: {
				type: Array
			},
			openKeys: {
				type: Array
			},
		},
		data() {
		  return {
		   openKey: this.openKeys
		  };
		 },

		computed: {
			collapsed: function() {
				return this.$store.state.collapsed || false
			}
		},
		methods: {
			handleClick(e) {
				this.$router.push(e.key);
			},
			openChange(openKeys) {
				this.openKey = openKeys;
			}
		}
	};
</script>

<style>
	.logo {
		height: 60px;
		line-height: 60px;
		color: white;
		margin: 15px;
	}
</style>



// WEBPACK FOOTER //
// menu_bar.vue?59dd0f4b